<div class="section pl-11px pt-17px pb-17px" *ngIf="limitedCollection && limitedCollection.items.length">
  <div class="centered-vert hov-cursor-p ml-7px" (click)="expanded = !expanded">
    <span class="ink-10-v3 fs-11px fw-600 tt-uppercase">{{ config.sectionLabelKey | localize }}</span>
    <span class="ink-10-v3 ml-5px fw-600">
      <span class="gh-font-icon-arrow-down-small" *ngIf="expanded"></span>
      <span class="gh-font-icon-arrow-right-small" *ngIf="!expanded"></span>
    </span>
  </div>
  <div class="mt-7px" *ngIf="expanded">
    <div class="drag-area" (cdkDropListDropped)="drop($event)" cdkDropList>
      <ng-template [ngForOf]="limitedCollection.items" ngFor let-i="index" let-item>
        <nav-list-item
          *ngIf="seeMore || i < config.visibleItemsCount"
          [item]="item"
          [config]="config"
          [attr.data-test-id]="'home-section-sub-nav-' + config.sectionLabelKey"
          (markItemAsFavorite)="markItemAsFavorite.emit($event)"
          (unmarkItemAsFavorite)="unmarkItemAsFavorite.emit($event)"
          (removeFromSuggested)="removeFromSuggested.emit($event)"></nav-list-item>
      </ng-template>
    </div>
    <div class="fs-11px mt-1px ml-23px ink-20-v3 hov-cursor-p" *ngIf="limitedCollection.totalCount - config.visibleItemsCount > 0" (click)="seeMore = !seeMore">
      <div *ngIf="!seeMore">{{ "view__more" | localize : { amount: limitedCollection.totalCount - config.visibleItemsCount } }}</div>
      <div *ngIf="seeMore">{{ "view_less" | localize }}</div>
    </div>
  </div>
</div>
